export default __webpack_public_path__ + "5c5c8d72a3857e9d6c33c25f43fcd319.svg";